import { Dispatch } from "react";
import { Action, Reducer } from "redux";
import { CoreSelectableTriggerModule } from "../models/CoreModels";
import InstanceClient from "../services/InstanceClient";
import StatusCode from "../util/StatusCode";
import { RequestState } from "../models/RequestState";



enum ModuleTriggerType {
    GET_SELECTABLE_TRIGGERS = 'GET_SELECTABLE_TRIGGERS',
};

export interface ModuleTriggerState {
    selectableTriggers: RequestState<CoreSelectableTriggerModule[]>
};

interface ModuleTrigger_GetSelectableTriggers extends Action<ModuleTriggerType> {
    type: ModuleTriggerType.GET_SELECTABLE_TRIGGERS,
    selectableTriggers: RequestState<CoreSelectableTriggerModule[]>
};

type ModuleTriggerAction = ModuleTrigger_GetSelectableTriggers;

export const getSelectableModuleTriggers = (id: string) => (dispatch: Dispatch<ModuleTrigger_GetSelectableTriggers>) => {
    dispatch({
        type: ModuleTriggerType.GET_SELECTABLE_TRIGGERS,
        selectableTriggers: { code: StatusCode.PENDING }
    })
    return InstanceClient.get<CoreSelectableTriggerModule[]>(`/api/core/module/${id}/selectabletriggers`)
        .then(res => {
            dispatch({
                type: ModuleTriggerType.GET_SELECTABLE_TRIGGERS,
                selectableTriggers: {code: StatusCode.COMPLETE, data: res.data}
            })
        })
        .catch(error => {
            dispatch({
                type: ModuleTriggerType.GET_SELECTABLE_TRIGGERS,
                selectableTriggers: { code: StatusCode.ERROR, error }
            })
        })
};

const initialState: ModuleTriggerState = {
    selectableTriggers: { code: StatusCode.NONE },
};

export const reducer: Reducer<ModuleTriggerState, ModuleTriggerAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case ModuleTriggerType.GET_SELECTABLE_TRIGGERS:
            return {
                ...state,
                selectableTriggers: action.selectableTriggers
            };
        default:
            return state;
    }
}